import { render, staticRenderFns } from "./ExcCheckbox.vue?vue&type=template&id=33f8813b&scoped=true&"
import script from "./ExcCheckbox.vue?vue&type=script&lang=ts&"
export * from "./ExcCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./ExcCheckbox.vue?vue&type=style&index=0&id=33f8813b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f8813b",
  null
  
)

export default component.exports